import React from 'react';
import { observer } from 'mobx-react-lite';
import ImageElementComponent from './image-element';
import TextElementComponent from './text-element';
import SVGElementComponent from './svg-element';
import FigureElementComponent from './figure-element';
import LineElementComponent from './line-element';
import GroupElementComponent from './group-element';

const ELEMENT_RENDERERS = {
  image: ImageElementComponent,
  text: TextElementComponent,
  svg: SVGElementComponent,
  figure: FigureElementComponent,
  line: LineElementComponent,
  group: GroupElementComponent,
};

const ElementRenderer = observer(({ element, isSelected, onSelect, onTransformEnd, onDragEnd, groupChild }) => {
  const Renderer = ELEMENT_RENDERERS[element.type];

  if (!Renderer) {
    console.warn(`No renderer for element type: ${element.type}`);
    return null;
  }

  // Pass ElementRenderer itself to GroupElementComponent to avoid circular imports
  const extra = element.type === 'group' ? { _ElementRenderer: ElementRenderer } : {};

  return (
    <Renderer
      element={element}
      isSelected={isSelected}
      onSelect={onSelect}
      onTransformEnd={onTransformEnd}
      onDragEnd={onDragEnd}
      groupChild={groupChild}
      {...extra}
    />
  );
});

ElementRenderer.displayName = 'ElementRenderer';
export default ElementRenderer;
export { ELEMENT_RENDERERS };
